import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _pick from 'lodash/pick';
import _isNull from 'lodash/isNull';
import _isEqualWith from 'lodash/isEqualWith';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import FormEvent from '@tekion/tekion-base/utils/formEvent';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Content from '../../atoms/Content';
import withEventSubmission from './withEventSubmission';
import Page from '../../molecules/pageComponent/PageComponent';
import Label from '../../atoms/Label';
import withSize from '../../hoc/withSize';
import eventTypes from './constants/eventTypes';

// Components
import HeaderComponent from './molecules/HeaderComponent';
import BodyComponent from './organisms/BodyComponent';
import FooterComponent from './molecules/FooterComponent';
import Modal from '../../molecules/Modal';

// Constants

var PAGE_HEADER_PROPS = ['goBackTo', 'hasBack', 'className', 'onBack', 'isBackDisabled', 'backButtonTooltipTitle', 'contentClassName'];
var PAGE_BODY_STYLE = {
  display: 'flex',
  minHeight: '0',
  flex: '1 0 0'
};
var getOnCancelEvent = function getOnCancelEvent(contextId) {
  return "".concat(eventTypes.ON_CANCEL, ":").concat(contextId);
};
var FormPage = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormPage, _PureComponent);
  var _super = _createSuper(FormPage);
  function FormPage(_props) {
    var _this;
    _classCallCheck(this, FormPage);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "closeDialog", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        props = _assertThisInitialize.props;
      _this.setState({
        showConfirmationBox: false
      });
      props.onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDialogBox", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        _assertThisInitialize3 = _assertThisInitialize2.state,
        showConfirmationBox = _assertThisInitialize3.showConfirmationBox,
        initialFormValues = _assertThisInitialize3.initialFormValues;
      var _this$props = _this.props,
        values = _this$props.values,
        onClose = _this$props.onClose,
        checkFormStateOnCancel = _this$props.checkFormStateOnCancel;
      if (!_isEqualWith(initialFormValues, values, checkFormStateOnCancel)) {
        _this.setState({
          showConfirmationBox: !showConfirmationBox
        });
      } else {
        onClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderConfirmationBox", function () {
      var showConfirmationBox = _this.state.showConfirmationBox;
      var _this$props$confirmat = _this.props.confirmationBoxProps,
        confirmationBoxProps = _this$props$confirmat === void 0 ? EMPTY_OBJECT : _this$props$confirmat;
      var title = confirmationBoxProps.title,
        label = confirmationBoxProps.label,
        message = confirmationBoxProps.message,
        labelClass = confirmationBoxProps.labelClass,
        messageClass = confirmationBoxProps.messageClass,
        submitBtnText = confirmationBoxProps.submitBtnText;
      return /*#__PURE__*/React.createElement(Modal, {
        visible: showConfirmationBox,
        title: title,
        width: Modal.SIZES.MD,
        submitBtnText: submitBtnText,
        onSubmit: _this.closeDialog,
        onCancel: _this.toggleDialogBox,
        destroyOnClose: true
      }, !_isEmpty(label) && /*#__PURE__*/React.createElement(Label, {
        className: labelClass
      }, label), /*#__PURE__*/React.createElement(Content, {
        className: messageClass
      }, message));
    });
    _defineProperty(_assertThisInitialized(_this), "renderFormHeader", function () {
      var _assertThisInitialize4 = _assertThisInitialized(_this),
        props = _assertThisInitialize4.props;
      var FormHeaderComponent = props.headerComponent;
      return /*#__PURE__*/React.createElement(FormHeaderComponent, props.headerProps);
    });
    _defineProperty(_assertThisInitialized(_this), "renderFormBody", function () {
      var _assertThisInitialize5 = _assertThisInitialized(_this),
        props = _assertThisInitialize5.props;
      var FormBodyComponent = props.bodyComponent;
      return /*#__PURE__*/React.createElement(FormBodyComponent, _extends({
        key: 1,
        sections: props.sections,
        fields: props.fields,
        values: props.values,
        errors: props.errors,
        warnings: props.warnings,
        onAction: props.onAction,
        contentHeight: props.contentHeight,
        shouldAvoidFieldValidation: props.shouldAvoidFieldValidation,
        useKeyBoardShortcuts: props.useKeyBoardShortcuts,
        isFormDisabled: props.isFormDisabled
      }, props.bodyProps));
    });
    _defineProperty(_assertThisInitialized(_this), "renderFormFooter", function () {
      var _assertThisInitialize6 = _assertThisInitialized(_this),
        props = _assertThisInitialize6.props;
      var FormFooterComponent = props.footerComponent;
      return /*#__PURE__*/React.createElement(FormFooterComponent, _extends({
        onSubmit: props.handleSubmit,
        onCancel: _this.toggleDialogBox,
        primaryActionLoading: props.loading
      }, props.footerProps));
    });
    FormEvent.on(getOnCancelEvent(_props.contextId), _this.toggleDialogBox);
    _this.state = {
      showConfirmationBox: false,
      initialFormValues: _props.values
    };
    return _this;
  }
  _createClass(FormPage, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;
      FormEvent.removeListener(getOnCancelEvent(props.contextId), this.toggleDialogBox);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        headerProps = _this$props2.headerProps,
        containerClassName = _this$props2.containerClassName,
        history = _this$props2.history,
        headerComponent = _this$props2.headerComponent,
        footerComponent = _this$props2.footerComponent,
        bodyClassName = _this$props2.bodyClassName;
      return /*#__PURE__*/React.createElement(Page, {
        className: containerClassName
      }, !_isNull(headerComponent) && /*#__PURE__*/React.createElement(Page.Header, _extends({
        history: history
      }, _pick(headerProps, PAGE_HEADER_PROPS)), this.renderFormHeader()), /*#__PURE__*/React.createElement(Page.Body, {
        className: bodyClassName,
        style: PAGE_BODY_STYLE
      }, this.renderFormBody(), this.renderConfirmationBox()), !_isNull(footerComponent) && /*#__PURE__*/React.createElement(Page.Footer, null, this.renderFormFooter()));
    }
  }]);
  return FormPage;
}(PureComponent);
_defineProperty(FormPage, "propTypes", {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string
    })
  }).isRequired
});
FormPage.propTypes = {
  bodyComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  headerComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  footerComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  confirmationBoxProps: PropTypes.shape({
    title: PropTypes.string,
    label: PropTypes.string,
    message: PropTypes.string,
    labelClass: PropTypes.string,
    messageClass: PropTypes.string
  }),
  checkFormStateOnCancel: PropTypes.func,
  onClose: PropTypes.func,
  headerProps: PropTypes.object,
  containerClassName: PropTypes.string,
  history: PropTypes.object
};
FormPage.defaultProps = {
  bodyComponent: BodyComponent,
  headerComponent: HeaderComponent,
  footerComponent: FooterComponent,
  confirmationBoxProps: {
    title: __('Cancel Changes'),
    label: '',
    message: __('Are you sure you want to cancel all the changes made by you? All data will be lost if you click yes.'),
    labelClass: '',
    messageClass: '',
    submitBtnText: __('Yes')
  },
  checkFormStateOnCancel: _noop,
  onClose: _noop,
  headerProps: EMPTY_OBJECT,
  containerClassName: '',
  history: EMPTY_OBJECT
};
export default compose(withSize({
  hasPageHeader: 1,
  hasPageFooter: 1
}), withEventSubmission)(FormPage);